var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircleSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.3125C8.27988 3.3125 2.8125 8.77988 2.8125 15.5C2.8125 22.2201 8.27988 27.6875 15 27.6875C21.7201 27.6875 27.1875 22.2201 27.1875 15.5C27.1875 8.77988 21.7201 3.3125 15 3.3125ZM20.625 16.4375H15.9375V21.125H14.0625V16.4375H9.375V14.5625H14.0625V9.875H15.9375V14.5625H20.625V16.4375Z",
    fill: "#413E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleSharp);
export default __webpack_public_path__ + "static/media/add-circle-sharp.27af8f6b4cc4cd3770cefe7866eadd93.svg";
export { ForwardRef as ReactComponent };